<template>
  <div>
    <div class="document-upload col-12 edit__container">
      <h1 class="document-upload__title edit__title">Modifez votre CDC :</h1>
      <FileUpload
        v-if="uploadDocument"
        :name="document.name || 'CDC'"
        :placeholder="document.name || 'CDC'"
        class="col-5"
        :acceptedTypes="['application/pdf']"
        @file-upload="handleCdcUpload($event)"
      />

      <template v-else>
        <span class="document-upload__name edit__update">{{
          document.name
        }}</span>
        <base-link path @click.native.prevent="changeUploadCdc"
          >modifier</base-link
        >
      </template>
    </div>
    <base-button class="edit__button" @click.native="handleSubmit"
      >Modifier</base-button
    >
  </div>
</template>

<script>
import FileUpload from "@/components/FileUpload.vue"
import { mapGetters } from "vuex"
import { Message } from "element-ui"
import { uploadCampaignCdc } from "@/api/campaigns"
export default {
  components: {
    FileUpload
  },
  computed: {
    ...mapGetters(["modal", "userInfo"])
  },
  data() {
    return {
      uploadDocument: true,
      document: { name: "" }
    }
  },
  created() {
    this.document.name = this.modal.payload.row.cdc
  },
  methods: {
    handleCdcUpload(file) {
      this.uploadDocument = false
      this.document = file
    },
    changeUploadCdc() {
      // this.uploadDocument = true
      setTimeout(() => {
        this.uploadDocument = true
      }, 10)
    },
    async handleSubmit() {
      const formData = new FormData()
      formData.append("cdc", this.document)
      await uploadCampaignCdc(this.modal.payload.row.id, formData)
      Message.success("Cdc Téléchargé")
      this.$root.$emit("cdcEdited")
      this.$store.dispatch("closeModal")
    }
  }
}
</script>

<style lang="scss" scoped>
.edit {
  &__title {
    margin: 0 0 20px 0;
  }
  &__button {
    margin-top: 20px;
  }
  &__container {
    width: 600px;
  }
  &__update {
    margin-left: 16px;
  }
}
</style>
